/** Web does not use Firebase for performance tracing */

export default {
    startTrace() {},
    stopTrace() {},
};
